@if (header) {
  <header class="type-selector-header">
    <h2>{{ header }}</h2>
  </header>
}

<div class="type-selector-container">
  @for (option of options; track option) {
    <div
      class="type-selector-tile"
      (click)="select(option.value)"
      [ngClass]="{ selected: option.value === selectedValue }"
    >
      <div class="type-selector-title">
        @if (option.icon) {
          <span class="type-selector-icon" [inlineSVG]="option.icon"></span>
        }
        <h2>{{ option.title | transloco }}</h2>
      </div>
      <p>{{ option.description | transloco }}</p>
      <button class="btn-dark-theme btn-light" type="button">
        @if (selectedValue === option.value) {
          <div class="selected-circle">
            <span inlineSVG="/icons/icon-success-2.svg"></span>
          </div>
        }
        <span>{{ selectedValue === option.value ? selectedLabel : selectLabel }}</span>
      </button>
    </div>
  }
</div>

@if (showSubmit) {
  <button class="btn btn-dark-theme btn-primary submit-btn" [disabled]="!hasSelection" (click)="next.emit()">
    {{ submitLabel }}
  </button>
}
